export default "__VITE_ASSET__B5sQe49l__"